import ObjectUtils from '../system/ObjectUtils';
export default class Url {
    constructor(path, queryParams = {}) {
        this.queryParams = {};
        this.path = path;
        this.queryParams = queryParams;
        for (const key in queryParams) {
            if (queryParams[key] == undefined) {
                delete queryParams[key];
            }
        }
    }
    static urlEncode(obj) {
        return Url.queryParamsToString(Url.objectToQueryParams(obj));
    }
    static queryParamsToString(queryParams) {
        let paramString = '';
        if (ObjectUtils.keyCount(queryParams) > 0) {
            for (const key in queryParams) {
                const paramValue = queryParams[key];
                if (Array.isArray(paramValue)) {
                    for (const value of paramValue) {
                        paramString = paramString.concat(`${key}=${encodeURIComponent(value)}`, '&');
                    }
                }
                else {
                    paramString = paramString.concat(`${key}=${encodeURIComponent(paramValue)}`, '&');
                }
            }
        }
        return paramString;
    }
    static objectToQueryParams(obj) {
        const queryParams = [];
        for (const key in obj) {
            queryParams[key] = obj[key];
        }
        return queryParams;
    }
    static tryParse(urlStr = window.location.href) {
        var _a;
        const url = new Url();
        const match = (_a = /^(?:([^:]+)(?::\/))?\/?([^:/?]+)(?::([0-9]+))?([^?]+)?\??(.+)?$/i.exec(urlStr)) !== null && _a !== void 0 ? _a : undefined;
        if (!match || match.length <= 1) {
            return undefined;
        }
        if (match.length > 1 && match[1]) {
            url.protocol = match[1];
        }
        if (match.length > 2 && match[2]) {
            url.host = match[2];
        }
        if (match.length > 3 && match[3]) {
            url.port = parseInt(match[3]);
        }
        if (match.length > 4 && match[4]) {
            url.path = match[4];
        }
        let queryParamStr = '';
        if (match.length > 5 && match[5]) {
            queryParamStr = match[5];
        }
        const splittedParams = queryParamStr.split('&');
        for (const param of splittedParams) {
            if (param.indexOf('=') !== -1) {
                const name = param.substring(0, param.indexOf('='));
                const value = param.substring(param.indexOf('=') + 1);
                url.queryParams[name] = value;
            }
        }
        return url;
    }
    static getParameter(urlStr = window.location.href, paramName) {
        const url = this.tryParse(urlStr);
        if (url && paramName in url.queryParams) {
            return url.queryParams[paramName];
        }
        else {
            return undefined;
        }
    }
    toString() {
        var _a;
        return ''.concat((_a = this.protocol) !== null && _a !== void 0 ? _a : '')
            .concat(this.host ? ('://' + this.host) : '')
            .concat(this.port !== undefined ? (':' + this.port.toString()) : '')
            .concat(this.path ? ('/' + this.path) : '')
            .concat(ObjectUtils.keyCount(this.queryParams) > 0 ? ('?' + Url.queryParamsToString(this.queryParams)) : '');
    }
}
//# sourceMappingURL=Url.js.map